import '@fortawesome/fontawesome-pro/css/all.min.css';
import '@fortawesome/fontawesome-pro/css/sharp-solid.css';
import 'styles/main/front-royal.scss';
import { bootstrapFrontRoyalApp } from 'FrontRoyalReact';

bootstrapFrontRoyalApp();
